<template>
	<div id="app">
		<component :is="layout">
			<router-view :key="$route.meta.menuSurface ? 'v2-menu:' + $route.params.companySlug + ':' + $route.params.branchSlug + ':' + ($route.params.tableSlug || '') : $route.meta.orderingV2 ? $route.path : undefined" />
		</component>
	</div>
</template>

<style>
    /*@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');*/

    /* rubik-300 - latin */
    @font-face {
        font-display: swap;
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 300;
        src: url('/assets/fonts/rubik-v28-latin-300.woff2') format('woff2'),
        url('/assets/fonts/rubik-v28-latin-300.ttf') format('truetype');
    }
    /* rubik-regular - latin */
    @font-face {
        font-display: swap;
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 400;
        src: url('/assets/fonts/rubik-v28-latin-regular.woff2') format('woff2'),
        url('/assets/fonts/rubik-v28-latin-regular.ttf') format('truetype');
    }
    /* rubik-500 - latin */
    @font-face {
        font-display: swap;
        font-family: 'Rubik';
        font-style: normal;
        font-weight: 500;
        src: url('/assets/fonts/rubik-v28-latin-500.woff2') format('woff2'),
        url('/assets/fonts/rubik-v28-latin-500.ttf') format('truetype');
    }

	html {
		scroll-behavior: smooth;
	}

	body {
		position: relative;
		height: 100%;
		font-family: "Rubik", sans-serif !important;
	}

	input[type="checkbox"],
	input[type="radio"] {
		width: 22px;
		height: 22px;
	}

	b,
	strong {
		font-weight: 500 !important;
	}

	a, .btn-link {
		text-decoration: none !important;
	}

	.pace {
		-webkit-pointer-events: none;
		pointer-events: none;
		-webkit-user-select: none;
		-moz-user-select: none;
		user-select: none;
	}

	.pace-inactive {
		display: none;
	}

    .pace .pace-progress {
        background: var(--bs-primary);
        position: fixed;
        z-index: 2000;
        top: 0;
        right: 100%;
        width: 100%;
        height: 2px;
    }

	.btn-orange {
		background-color: #f37022 !important;
		color: #ffffff !important;
	}

	.btn-orange:hover {
		background-color: #f37022 !important;
		color: #ffffff !important;
	}

	.text-orange {
		color: #f37022;
	}

	.text-orange:hover {
		color: #f37022;
	}
</style>

<script>
	import { defineAsyncComponent } from "vue";
	const V2Layout = defineAsyncComponent(() => import("../v2/layouts/Layout.vue"));
	import DefaultLayout from "./layouts/defaultLayout.vue";
    import PortalLayout from "./layouts/portalLayout.vue";
	import StoreLayout from "./layouts/storeLayout.vue";
	import FramelessLayout from "./layouts/framelessLayout.vue";

	export default {
		name: "App",

		data() {
			return {
			};
		},

		computed: {
			layout() {
				return (this.$route.meta.layout || "Default") + "Layout";
				//return 'StoreLayout';
			},
		},

		components: { V2Layout, DefaultLayout, PortalLayout, StoreLayout, FramelessLayout },
	};
</script>
